import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "@/assets/tailwind.css";
import VueApexCharts from "vue-apexcharts";
import * as VueGoogleMaps from "vue2-google-maps";
import VueGtm from "vue-gtm";
import http from "./http";

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_MIX_GOOGLE_MAP_API_KEY,
    libraries: "places"
  },
  installComponents: true
});

Vue.use(VueGtm, {
  id: "GTM-PVCPGM8", // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  vueRouter: router // Pass the router instance to automatically sync with router (optional)
});

Vue.config.productionTip = false;

Vue.prototype.$http = http;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
